/**
 * Custom Edge Component
 * Enhanced edge with center handle for easier selection
 */

import React, { memo } from 'react';
import { BaseEdge, EdgeProps, getBezierPath } from '@xyflow/react';

const CustomEdgeComponent: React.FC<EdgeProps> = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Get the stroke color from the edge style, default to white
  const strokeColor = (style as React.CSSProperties).stroke || '#ffffff';

  return (
    <>
      <BaseEdge 
        path={edgePath} 
        markerEnd={markerEnd} 
        style={{ 
          ...style, 
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }} 
      />
      {/* Center handle/dot - matches line color */}
      <circle
        cx={labelX}
        cy={labelY}
        r={4}
        fill={strokeColor}
        stroke={selected ? '#ffffff' : strokeColor}
        strokeWidth={selected ? 2 : 1}
        style={{
          cursor: 'pointer',
          opacity: 0,
          filter: selected ? 'drop-shadow(0 0 6px rgba(255, 255, 255, 0.9))' : 'none',
        }}
      />
    </>
  );
};

/**
 * Memoized CustomEdge to prevent re-renders when edge props haven't changed
 * This is critical for performance during mouse movement
 */
export const CustomEdge = memo(CustomEdgeComponent);

export default CustomEdge;
